var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "15px",
    viewBox: "0 0 10 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Arrow / Blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schedule-/-Admin-/-Grid-view-/-Previous-day",
    transform: "translate(-28.000000, -12.000000)",
    fill: "#3E82FF",
    stroke: "#3E82FF",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(28.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Arrow-/-Blue",
    transform: "translate(5.000000, 10.000000) scale(1, -1) translate(-5.000000, -10.000000) translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.98125066,9.8875 C9.03958428,9.94583362 9.06875066,10.0333327 9.06875066,10.15 C9.06875066,10.2666673 9.03958428,10.3541664 8.98125066,10.4125 C6.44373797,12.7166782 5.16041747,13.8833332 5.13125066,13.9125 C5.07291703,13.9708336 4.98541791,14 4.86875066,14 C4.75208341,14 4.66458428,13.9708336 4.60625066,13.9125 L0.756250656,10.4125 C0.581249781,10.2374991 0.581249781,10.0625009 0.756250656,9.8875 C0.931251531,9.71249912 1.10624978,9.71249912 1.28125066,9.8875 L4.51875066,12.81875 L4.51875066,0.35 C4.51875066,0.1166655 4.63541616,0 4.86875066,0 C5.10208516,0 5.21875066,0.1166655 5.21875066,0.35 L5.21875066,12.81875 L8.45625066,9.8875 C8.63125153,9.71249912 8.80624978,9.71249912 8.98125066,9.8875 Z",
    id: "ion-ios-arrow-thin-down---Ionicons"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIcon);
export default __webpack_public_path__ + "static/media/arrow-up-icon.6d47d538b5421fa3dbbf8b720fe269ca.svg";
export { ForwardRef as ReactComponent };